
import UserCirlceAdd from "../../../assets/duotone/UserCirlceAdd.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function UserCirlceAddIcon({ className, dataTestid = "UserCirlceAddIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <UserCirlceAdd data-testid={dataTestid} className={classes} {...rest} />
  );
}
